import send from './index';

export default {
    // 存款方式
    getDepositList(data: any = {}) {
        return send({ data, url: '/recharge/rechargeType/findMyRechargeChannel', method: 'POST' });
    },

    // 存款提交
    depositSubmit(data: any = {}) {
        return send({ data, url: '/recharge/rechargeOrder/submitRechargeOrder', method: 'POST' });
    },

    // 获取首充复充的订单
    findNotSendEvent(data: any = {}) {
        return send({ data, url: '/recharge/rechargeOrder/findNotSendEvent', method: 'POST' });
    },

    // 标记订单已发送
    sendEvent(data: any = {}) {
        return send({ data, url: '/recharge/rechargeOrder/sendEvent', method: 'POST' });
    },

    // 补单
    fillOrder(data: any = {}) {
        return send({ data, url: '/recharge/rechargeOrder/fillOrder', method: 'POST' });
    },

    // 存款优惠列表
    getDepositDiscountList(data: any = {}) {
        return send({ data, url: '/preferential/preferentialActivity/findPreferentialRecharge'});
    },

    // 存款优惠规则列表
    getDepositDiscountRuleList(data: any = {}) {
        return send({ data, url: `/preferential/preferentialActivity/findPreferentialRechargeRules/${data}` });
    },

    // 获取证件类型列表
    getIdentificationTypeEnums(data: any = {}) {
        return send({ data, url: '/member/getIdentificationTypeEnums', method: 'POST' });
    },

    // 提款对象
    getWithdrawalObj(data: any = {}) {
        return send({ data, url: '/withdraw/withdrawMethod/findWithdrawnSys'});
    },

    // 提款进度
    getWithdrawalProgress(data: any = {}) {
        return send({ data, url: `/withdraw/withdrawOrder/findMyWithdrawTop/${data?.type}` });
    },

    // 提款对象V2
    getFindBindCount(data: any = {}) {
        return send({ data, url: '/withdraw/withdrawMethod/findBindCount' });
    },

    // 非USDT已绑列表
    getNonDigitalList(data: any = {}) {
        return send({ data, url: `/member/memberWithdrawInfo/${data}`});
    },

    // USDT已绑列表
    getDigitalList(data: any = {}) {
        return send({ data, url: '/member/memberUserWallet/findMyWalletList'});
    },

    // 验证用户需要填写的资料信息是否完整
    checkWithdrawInfo(data: any = {}) {
        return send({ data, url: '/member/checkWithdrawInfo' });
    },

    // 验证密码
    verifyPassword(data: any = {}) {
        return send({ data, url: `/member/verifyWithdrawPwd/${data?.password}` });
    },

    // 提交提款申请非usdt
    submitWithdraw(data: any = {}) {
        return send({ data, url: '/withdraw/withdrawOrder/submitWithdrawOrder', method: 'POST' });
    },

    // 提交提款申请usdt
    submitWithdrawDigital(data: any = {}) {
        return send({ data, url: '/withdraw/withdrawOrder/submitVirtualWithdrawOrder', method: 'POST' });
    },

    // 获取还需要继续完成资料的字段
    getNeedToComplete(data: any = {}) {
        return send({ data, url: '/member/getComplete' });
    },

    // 已完成资料信息
    getCompleteInfo(data: any = {}) {
        return send({ data, url: '/member/getCompleteInfo' });
    },

    // 提交用户完善资料
    submitUserInfo(data: any = {}) {
        return send({ data, url: '/member/completeUserInfo', method: 'POST' });
    },

    // 获取银行卡类型下拉枚举
    getBankAccountOptions(data: any = {}) {
        return send({ data, url: '/sys/sysLanguage/findEnums', method: 'POST' });
    },

    // 银行下拉
    getBankOptions(data: any = {}) {
        return send({ data, url: '/member/memberWithdrawInfo/findBankTypeList' });
    },

    // pix下拉
    getPixOptions(data: any = {}) {
        return send({ data, url: '/member/memberWithdrawInfo/findPixType' });
    },

    // 数字钱包类型下拉
    getDigitalOptions(data: any = {}) {
        return send({ data, url: '/member/memberUserWallet/findWalletTypeList' });
    },

    // 游戏列表版本号
    getGameVersion(data: any = {}) {
        return send({ data, url: '/member/getGameVersion', method: 'POST' });
    },

    // 提交绑卡, 支付宝
    submitBindCard(data: any = {}) {
        return send({ data, url: '/member/memberWithdrawInfo/operate', method: 'POST' });
    },

    // 提交绑卡, 支付宝 v2版
    submitBindCardV2(data: any = {}) {
        return send({ data, url: '/member/memberWithdrawInfo/operateBankV2', method: 'POST' });
    },

    // 提交绑PIX
    submitBindPix(data: any = {}) {
        return send({ data, url: '/member/memberWithdrawInfo/operatePix', method: 'POST' });
    },

    // 提交绑PIX(新, 全绑定)
    submitBindPixs(data: any = {}) {
        return send({ data, url: '/member/memberWithdrawInfo/operatePixs', method: 'POST' });
    },

    // 提交绑数字钱包
    submitBindDigital(data: any = {}) {
        return send({ data, url: '/member/memberUserWallet/operate', method: 'POST' });
    },
};
